<template>
  <section class="info">
    <div class="info__content container">
      <div class="info__content--img">
        <img :src="imageUrl">
      </div>
      <div class="info__content--info">
        <p class="info__description">
          <b>
            With an astounding <i>98% open rate</i>, SMS surpasses emails (20%),
            ensuring your messages are seen instantly. Experience a 9.8% higher click-through rate,
            as concise SMS messages outperform lengthy emails, boasting a <i>19% click-through rate</i> compared to a mere 4%.
          </b>
          <br><br>
            Embrace unparalleled deliverability with less than <i>3% of SMS considered spam</i>,
            contrasting sharply with emails' 85%. SRAX proudly achieves a 93%+ Database delivery rate!
            Stand out in the crowded inbox landscape - while an average worker grapples with 121 daily emails,
            SMS campaigns offer a unique opportunity. Capitalize on a 4.5% higher response rate,
            leveraging the immediacy of text messages. Join the SMS revolution and witness a swift,
            effective, and engaging connection with your audience.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import mobileImageUrl from '@/assets/info/mobile-analytics.png';
import desktopImageUrl from '@/assets/info/analytics.png';

export default {
  setup() {
    const imageUrl = ref('');

    const updateImageUrl = () => {
      imageUrl.value = window.innerWidth <= 992 ? mobileImageUrl : desktopImageUrl;
    };

    onMounted(() => {
      updateImageUrl();
      window.addEventListener('resize', updateImageUrl);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateImageUrl);
    });

    return {
      imageUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/components/info.scss";
</style>
